import { render } from "./FormOTP.vue?vue&type=template&id=14c9920c&ts=true"
import script from "./FormOTP.vue?vue&type=script&lang=ts"
export * from "./FormOTP.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__